import { render, staticRenderFns } from "./Step2.vue?vue&type=template&id=2c941890"
import script from "./Step2.ts?vue&type=script&lang=ts&external"
export * from "./Step2.ts?vue&type=script&lang=ts&external"
import style0 from "./Step2.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports